import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Box, FormControl, FormLabel, FormGroup, FilledInput, Divider, Tab, Tabs, AppBar, IconButton, Icon, Button, Radio, RadioGroup, FormControlLabel, InputAdornment, Tooltip, Switch } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import DateRange from '../../common/date-range';
import PropTypes from 'prop-types';

import Loader from '../../common/loader';

import AuthContext from '../../context';
import { get, post } from '../../utils/api-services';
import helpers from '../../utils/helpers';
import ScannerMobileHistory from '../components/scanner-mobile-history';

const useStyles = makeStyles(() => ({
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    store: {
        width: '100%',
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none',
        }
    },
    outlined: {
        width: '100%',
        backgroundColor: 'transparent',
        borderColor: '#0d6efd',
        color: 'inherit',
        '&:hover': {
            backgroundColor: 'transparent',
            borderColor: '#0d6efd',
            boxShadow: 'none',
        }
    },
    adornment: {
        marginLeft: '0px',
        paddingLeft: '10px'
    },
    reloadButton: {
        marginRight: '0px',
        paddingRight: '0px'
    },
    wrapText: {
        "&>.MuiAlert-message": {
            whiteSpace: "pre-wrap",
        },
    },
    requiredValue: {
        fontWeight: "600",
        color: "rgba(255,0,0,1)",
    },
    vVisible: {
        visibility: 'visible'
    },
    vHidden: {
        visibility: 'hidden'
    },
    radioButtons: {
        marginBottom: 5,
    },
    dateRangeBox: {
        marginBottom: 10
    },
    search: {
        marginBottom: 15,
        marginTop: 0,
        width: '100%',
        backgroundColor: '#198754',
        borderColor: '#198754',
        '&:hover': {
            backgroundColor: '#198754',
            borderColor: '#198754',
            boxShadow: 'none',
        },
    },
    switch: {
        marginRight: 8,
        marginLeft: 10,
        '& .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: '#aab4be',
        }
    }
}));

//Functions for tabs
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ bgcolor: 'rgba(0, 0, 0, 0.1)' }} p={2}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
//------------------------------------

const defaultScan = {
    employee_code: '',
    employee: {},
    cc1: {},
    cc2_code: '',
    cc2: {},
    cc3_code: '',
    cc3: {},
    action: { id: '' },
    clock_type: ''
}

const defaultIcons = {
    employee_code: 'warning',
    cc2_code: 'warning',
    cc3_code: 'warning'
}
const ScannerPaylocityMobile = ({ alone = false }) => {
    const defaultFilter = {
        startDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        dateRange: `${dayjs().subtract(1, 'day').format('MM/DD/YYYY')} - ${dayjs().format('MM/DD/YYYY')}`,
    }

    const defaultDateRange = {
        open: false,
        range: [
            {
                startDate: new Date(dayjs().subtract(1, 'day')),
                endDate: new Date(),
                key: 'main'
            }
        ]
    }

    const sede = JSON.parse(window.localStorage.getItem('@sede'));
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const classes = useStyles();
    const { pathname } = useLocation();
    const [showKeyboard, setShowKeyboard] = useState(true)
    const [tabValue, setTabValue] = useState(0);
    const [showErrorReport, setShowErrorReport] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedEmployeeHistory, setSelectedEmployeeHistory] = useState({});
    const [state, setState] = useState({
        loading: true,
        departments: [],
        actions: [],
        historyEmployees: [],
        historyData: [],
        historyWarning: 0,
        filteredHistoryEmployees: [],
        scan: {
            ...defaultScan,
            date: dayjs().tz(sede.time_zone).format('YYYY-MM-DD'),
            time: dayjs().tz(sede.time_zone).format('HH:mm'),
        },
        scanIcons: {
            ...defaultIcons
        },
        filter: {
            ...defaultFilter
        },
        rangeModal: {
            ...defaultDateRange
        },
        permissions: {}
    });

    useEffect(() => {
        validatePermissions();
    }, []);

    useEffect(() => {
        let filtered = state.historyEmployees.filter(i => i.warning)
        setState(prev => ({ ...prev, historyWarning: filtered.length }))
        if (showErrorReport) {
            setState(prev => ({ ...prev, filteredHistoryEmployees: filtered }))
        } else {
            setState(prev => ({ ...prev, filteredHistoryEmployees: state.historyEmployees }))
        }
    }, [state.historyEmployees, showErrorReport])

    const validatePermissions = () => {
        const permissions = helpers.getPermissions(pathname);
        setState(prev => ({ ...prev, permissions }));

        (permissions.read_attr) ? makeRequest() : setState(prev => ({ ...prev, loading: false }));
    }

    const makeRequest = async () => {
        showLoader(true);
        const response = await get('/paylocityScannerMobile');
        if (response.status === 200) {
            setState(prev => ({ ...prev, loading: false, actions: response?.actions ?? [] }));
        } else {
            console.log('[Paylocity Scanner Mobile] makeRequest error', response);
            helpers.failRequest(response, showToast, signOut)
        }
        showLoader(false);
    }

    const hideKeyboard = ({ target }) => {
        setShowKeyboard(false)
        setTimeout(function () {
            // target.blur()
            setShowKeyboard(true)
        }, 100);
    }

    const handleChange = ({ target }) => {
        let field = state.scan[target.name.split("_")[0]] ?? '';
        let searchField = target.name.split("_")[1] ?? '';
        if (target.value.trim() !== field[searchField]) {
            setState(prev => ({ ...prev, scanIcons: { ...prev.scanIcons, [target.name]: 'warning' }, scan: { ...prev.scan, [target.name.split("_")[0]]: {} } }));
        }
        setState(prev => ({ ...prev, scan: { ...prev.scan, [target.name]: target.value.trim() } }));
    }

    const handleSwitchChange = (event) => { setShowErrorReport(event.target.checked) };

    const handleModal = () => setState(prev => ({ ...prev, rangeModal: { ...prev.rangeModal, open: !prev.rangeModal.open } }));

    const handleDateChange = item => {
        const { startDate, endDate } = item.main;
        const dateRange = `${dayjs(startDate.toISOString()).format('MM/DD/YYYY')} - ${dayjs(endDate.toISOString()).format('MM/DD/YYYY')}`;
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                dateRange,
                startDate: dayjs(startDate.toISOString()).format('YYYY-MM-DD'),
                endDate: dayjs(endDate.toISOString()).format('YYYY-MM-DD')
            },
            rangeModal: { ...prev.rangeModal, range: [item.main] }
        }));
    }

    const handleShowHistory = (code, name) => {
        setOpen(true)
        setSelectedEmployeeHistory({ code, name })
    };

    const clearField = (field) => {
        setState(prev => ({ ...prev, scan: { ...prev.scan, [field.split("_")[0]]: {}, [field]: '' }, scanIcons: { ...prev.scanIcons, [field]: 'warning' } }));
    };

    const validateForm = () => {
        const { employee, cc2, cc3, action, date, time, clock_type } = state.scan;
        let issues = 0;
        let msg = "";

        if (!employee?.id) {
            issues += 1;
            msg += "Employee can't be empty\n";
        }
        if (!employee?.cc1 || !employee?.cc1?.id === 0) {
            issues += 1;
            msg += "Employee does not have an associated Cost Center 1\n";
        }
        if (!cc2?.id) {
            issues += 1;
            msg += "Cost Center 2 can't be empty\n";
        }
        if (!cc3?.id) {
            issues += 1;
            msg += "Cost Center 3 can't be empty\n";
        }
        if (!action?.id || action.id === 0) {
            issues += 1;
            msg += "Action can't be empty\n";
        }
        if (!date) {
            issues += 1;
            msg += "Date can't be empty\n";
        }
        if (!time) {
            issues += 1;
            msg += "Time can't be empty\n";
        }
        if (!clock_type) {
            issues += 1;
            msg += "Clock type can't be empty\n";
        }

        if (issues === 0) {
            return true;
        } else {
            showToast(msg, "error", 4000, classes.wrapText);
            return false;
        }
    }

    const searchEmployee = async (e) => {
        const { value } = e.target;

        if (e.key === 'Enter') {
            showLoader(true);
            const response = await get(`/paylocityScannerMobile/${value}/searchEmployee`);
            if (response.status === 200) {
                setState(prev => ({
                    ...prev,
                    scan: {
                        ...prev.scan,
                        employee: response?.data ?? {},
                        cc1: response?.data?.cc1 ?? {},
                        cc2_code: response?.data?.cc2?.code ?? '',
                        //If there is no name, will replace with code
                        cc2: response?.data?.cc2 ? { ...response?.data?.cc2, name: response?.data?.cc2?.name ?? response?.data?.cc2?.code } : {},
                        cc3_code: response?.data?.cc3?.code ?? '',
                        cc3: response?.data?.cc3 ? { ...response?.data?.cc3, name: response?.data?.cc3?.name ?? response?.data?.cc3?.code } : {}
                    },
                    scanIcons: {
                        ...prev.scanIcons,
                        employee_code: 'check',
                        cc2_code: response?.data?.cc2?.code ? 'check' : 'warning',
                        cc3_code: response?.data?.cc3?.code ? 'check' : 'warning',
                    }
                }));
            } else {
                console.log('[Paylocity Scanner Mobile] searchEmployee error', response);
                setState(prev => ({ ...prev, scanIcons: { ...prev.scanIcons, employee_code: 'error' } }));
                helpers.failRequest(response, showToast, signOut)
            }
            showLoader(false);
        }
    }

    const searchCc2 = async (e) => {
        const { value } = e.target;

        if (e.key === 'Enter') {
            showLoader(true);
            const response = await get(`/paylocityScannerMobile/${value}/searchCc2`);
            if (response.status === 200) {
                //If there is no name, will replace with code
                setState(prev => ({ ...prev, scan: { ...prev.scan, cc2: response?.data ? { ...response?.data, name: response?.data?.name ?? response?.data?.code } : {} }, scanIcons: { ...prev.scanIcons, cc2_code: 'check' } }));
            } else {
                console.log('[Paylocity Scanner Mobile] searchCc2 error', response);
                setState(prev => ({ ...prev, scanIcons: { ...prev.scanIcons, cc2_code: 'error' } }));
                helpers.failRequest(response, showToast, signOut)
            }
            showLoader(false);
        }
    }

    const searchCc3 = async (e) => {
        const { value } = e.target;

        if (e.key === 'Enter') {
            showLoader(true);
            const response = await get(`/paylocityScannerMobile/${value}/searchCc3`);
            if (response.status === 200) {
                //If there is no name, will replace with code
                setState(prev => ({ ...prev, scan: { ...prev.scan, cc3: response?.data ? { ...response?.data, name: response?.data?.name ?? response?.data?.code } : {} }, scanIcons: { ...prev.scanIcons, cc3_code: 'check' } }));
            } else {
                console.log('[Paylocity Scanner Mobile] searchCc2 error', response);
                setState(prev => ({ ...prev, scanIcons: { ...prev.scanIcons, cc3_code: 'error' } }));
                helpers.failRequest(response, showToast, signOut)
            }
            showLoader(false);
        }
    }

    const store = async () => {
        const cond = validateForm();

        if (cond) {
            showLoader(true);
            const response = await post('/paylocityScanner/store', { ...state.scan });
            if (response.status === 200) {
                clear();
                showToast(response.message);
            } else {
                console.log('[Paylocity Scanner Mobile] store error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const clear = () => {

        setState(prev => ({
            ...prev,
            scan: {
                ...defaultScan,
                date: dayjs().tz(sede.time_zone).format('YYYY-MM-DD'),
                time: dayjs().tz(sede.time_zone).format('HH:mm'),
            },
            scanIcons: {
                ...defaultIcons
            }
        }));
    }

    const searchHistory = async () => {
        showLoader(true);
        const response = await get('/paylocityScannerBlockMobile/searchHistory', state.filter);
        if (response.status === 200) {
            setState(prev => ({ ...prev, historyEmployees: response?.employees ?? [], historyData: response?.data ?? [] }));
            if (response?.data.length === 0) showToast('There are no data with these filters', 'warning');
        } else {
            console.log('[Paylocity Scanner Mobile] search error', response);
            helpers.failRequest(response, showToast, signOut)
        }
        showLoader(false);
    }

    const renderCell = ({ row }) => {
        if (row.warning) {
            return (
                <IconButton disabled>
                    <Icon style={{ color: "orange" }}>{"warning"}</Icon>
                </IconButton>
            )
        } else {
            return (
                <IconButton disabled>
                    <Icon style={{ color: "green" }}>{"check"}</Icon>
                </IconButton>
            );
        }

    };

    const renderCellButton = ({ row }) => {
        return (
            <Tooltip title="Show History" placement="top">
                <IconButton onClick={e => handleShowHistory(row.code, row.name)}>
                    <Icon>{"visibility"}</Icon>
                </IconButton>
            </Tooltip>
        );
    };

    const columnsHistory = [
        { field: 'custom', headerName: 'Status', flex: 0.2, renderCell },
        { field: 'code', headerName: 'Code' },
        { field: 'name', headerName: 'Name' },
        { field: 'Action', headerName: 'Action', flex: 0.2, renderCell: renderCellButton },
    ];

    const reloadTime = () => {
        setState(prev => ({ ...prev, scan: { ...prev.scan, time: dayjs().tz(sede.time_zone).format('HH:mm') } }));
        showToast("Time updated")
    }

    if (state.loading) {
        return <Loader />;
    }

    return (
        <>
            <div className={classes.root}>
                <AppBar position="static" color="default">
                    <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="primary"
                        aria-label="Show data">
                        <Tab label="New Scan" {...a11yProps(0)} />
                        <Tab label="History" {...a11yProps(1)} onClick={searchHistory} />
                    </Tabs>
                </AppBar>
                <TabPanel value={tabValue} index={0}>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                                <FormLabel>{'Code - Employee'}<span className={classes.requiredValue}>*</span></FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        autoComplete='off'
                                        type='text'
                                        placeholder='Code employee'
                                        name='employee_code'
                                        value={state.scan.employee_code}
                                        readOnly={!showKeyboard}
                                        onFocus={e => hideKeyboard(e)}
                                        startAdornment={<InputAdornment position="start"><Icon>{state.scanIcons.employee_code}</Icon></InputAdornment>}
                                        onChange={handleChange}
                                        onKeyPress={searchEmployee}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    className={state.scan.employee_code ? classes.vVisible : classes.vHidden}
                                                    aria-label="Clear employee code"
                                                    onClick={e => clearField('employee_code')}
                                                    edge="end"
                                                >
                                                    <Icon>{'clear'}</Icon>
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                                <FormLabel>{'Employee'}</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        autoComplete='off'
                                        disabled={true}
                                        type='text'
                                        placeholder='Employee'
                                        value={state.scan.employee?.name ?? ''}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                                <FormLabel>{'Code - Cost Center 2'}<span className={classes.requiredValue}>*</span></FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        className={classes.adornment}
                                        type='text'
                                        placeholder='Code - Cost center 2'
                                        name='cc2_code'
                                        startAdornment={<InputAdornment position="start"><Icon>{state.scanIcons.cc2_code}</Icon></InputAdornment>}
                                        value={state.scan?.cc2_code ?? ''}
                                        onChange={handleChange}
                                        onKeyPress={searchCc2}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    className={state.scan.cc2_code ? classes.vVisible : classes.vHidden}
                                                    aria-label="Clear cc2 code"
                                                    onClick={e => clearField('cc2_code')}
                                                    edge="end"
                                                >
                                                    <Icon>{'clear'}</Icon>
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                                <FormLabel>{'Cost Center 2 (Cost)'}</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        autoComplete='off'
                                        disabled={true}
                                        type='text'
                                        placeholder='Cost Center 2'
                                        value={state.scan.cc2?.name ?? ''}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                                <FormLabel>{'Code - Cost Center 3 (Cost)'}<span className={classes.requiredValue}>*</span></FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        className={classes.adornment}
                                        type='text'
                                        placeholder='Code - Cost center 3'
                                        name='cc3_code'
                                        startAdornment={<InputAdornment position="start"><Icon>{state.scanIcons.cc3_code}</Icon></InputAdornment>}
                                        value={state.scan?.cc3_code ?? ''}
                                        onChange={handleChange}
                                        onKeyPress={searchCc3}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    className={state.scan.cc3_code ? classes.vVisible : classes.vHidden}
                                                    aria-label="Clear cc3 code"
                                                    onClick={e => clearField('cc3_code')}
                                                    edge="end"
                                                >
                                                    <Icon>{'clear'}</Icon>
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                                <FormLabel>{'Cost Center 3 (Team)'}</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        autoComplete='off'
                                        disabled={true}
                                        type='text'
                                        placeholder='Cost Center 3'
                                        value={state.scan.cc3?.name ?? ''}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup className={classes.radioButtons}>
                                <FormLabel>Action<span className={classes.requiredValue}>*</span></FormLabel>
                                <RadioGroup row className={classes.radioButtons} name="action" value={state.scan.action.id} onChange={e => setState(prev => ({ ...prev, scan: { ...prev.scan, action: { id: e.target.value } } }))}>
                                    {state.actions.map(a => (<FormControlLabel value={`${a.id}`} control={<Radio disableRipple color='default' />} label={a.name} />))}
                                </RadioGroup>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <FormGroup>
                                <FormLabel>{'Date'}<span className={classes.requiredValue}>*</span></FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        autoComplete='off'
                                        type='date'
                                        placeholder='Date'
                                        name='date'
                                        value={state.scan.date}
                                        onChange={handleChange}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={7} sm={7} md={7}>
                            <FormGroup>
                                <FormLabel>{'Time'}<span className={classes.requiredValue}>*</span></FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        autoComplete='off'
                                        type='time'
                                        placeholder='Time'
                                        name='time'
                                        className={classes.adornment}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <Tooltip title="Set actual time">
                                                    <IconButton
                                                        className={classes.reloadButton}
                                                        aria-label="Set actual time"
                                                        onClick={reloadTime}
                                                        edge="start"
                                                    >
                                                        <Icon>{'replay'}</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        }
                                        value={state.scan?.time ?? dayjs().tz(sede.time_zone).format('HH:mm')}
                                        onChange={handleChange}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid xs={5} sm={5} md={5}>
                            <FormGroup>
                                <FormLabel>Clock<span className={classes.requiredValue}>*</span></FormLabel>
                                <RadioGroup row name="radioClock" value={state.scan.clock_type} onChange={e => setState(prev => ({ ...prev, scan: { ...prev.scan, clock_type: e.target.value } }))}>
                                    <FormControlLabel value="In" control={<Radio disableRipple color='default' />} label="In" />
                                    <FormControlLabel value="Out" control={<Radio disableRipple color='default' />} label="Out" />
                                </RadioGroup>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} className={classes.buttonContainer}>
                            <Button
                                variant='contained'
                                className={classes.store}
                                onClick={store}
                            >
                                {'Store'}
                            </Button>
                        </Grid>
                    </Grid>

                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                    <Grid container>
                        <Grid item sm={12} md={12} xs={12}>
                            <FormGroup className={classes.dateRangeBox} onClick={handleModal}>
                                <FormLabel>{'Date range'}</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                >
                                    <FilledInput
                                        readOnly
                                        type='text'
                                        placeholder='Date range'
                                        value={state.filter.dateRange}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>
                        <Grid item sm={12} md={12} xs={12}>
                            <Button onClick={searchHistory} variant='contained' className={classes.search}>Search</Button>
                            <FormControlLabel
                                style={{ marginBottom: 10 }}
                                control={<Switch checked={showErrorReport} onChange={handleSwitchChange} className={classes.switch} />
                                }
                                label={`Show only employees with unclosed task`}
                            />
                        </Grid>
                    </Grid>

                    <Divider style={{ marginBottom: 15 }} />

                    <div className={classes.tableContainer} style={{ display: 'flex', flexDirection: 'column' }}>
                        <DataGrid
                            rows={state.filteredHistoryEmployees}
                            columns={columnsHistory}
                            pageSize={45}
                            density='compact'
                            autoHeight
                            getRowId={row => row.code}
                        />
                    </div>
                </TabPanel>
            </div>

            <DateRange
                open={state.rangeModal.open}
                range={state.rangeModal.range}
                onClose={handleModal}
                onChange={handleDateChange}
            />

            <ScannerMobileHistory open={open} onClose={() => setOpen(false)} employee={selectedEmployeeHistory} data={state.historyData[selectedEmployeeHistory.code]} />
        </>
    );
}

export default ScannerPaylocityMobile;